import dayjs from 'dayjs';
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)

export function useInputValidation() {
    function isNonEmpty(value) {
        return (value !== ''
            && value !== []
            && value !== {}
            && value !== undefined
            && value !== null);
    }

    function isEmailAddress(value) {
        // eslint-disable-next-line no-control-regex
        let reqEx = /^(?:[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
        return (reqEx.test(value));
    }

    function isMonth(value) {
        return dayjs(value, 'YYYY-MM', true).isValid();
    }
    function isDate(value) {
        return dayjs(value).isValid();
    }
    function isPeriod(start, end) {
        return dayjs(start).isSameOrBefore(end);
    }

    return {
        isNonEmpty,
        isEmailAddress,
        isMonth,
        isDate,
        isPeriod
    }
}